//@ts-nocheck
import { Node } from 'tiptap'

export class Source extends Node {
  get name() {
    return 'source'
  }

  get schema() {
    return {
      content: 'inline*',
      group: 'video',
      attrs: { src: { default: '' }, type: { default: '' } },
      parseDOM: [{ tag: 'source', getAttrs: dom => ({ src: dom.src, type: dom.type }) }],
      toDOM: node => ['source', node.attrs],
    }
  }
}
